<nav role="navigation">
  <ul class="menu menu--global" role="menu">
    <li role="menuitem"><a class="link--on-dark" routerLink="/">Home</a></li>
    <li role="menuitem"><a class="link--on-dark" [routerLink]="['contract-summary']">Summary</a></li>
    <!-- <li role="menuitem" [opusAuthorize]="'Distribution.ViewShippingCharges'"><a class="link--on-dark" [routerLink]="['distribution']">Distribution</a></li> -->
    <!-- <li role="menuitem"><a class="link--on-dark" routerLink="/user-management">User Management</a></li> -->
  </ul>
</nav>
